import { IonApp, IonButton, IonContent } from "@ionic/react";
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Toolbar from "../../components/Toolbar";
import { URLS } from "../../urls";
import "./style.css";

const Error404: React.FC = () => {
    return (
        <IonApp>
            <Toolbar />
            <IonContent style={{ textAlign: "center" }}>
                <br />
                <h1>ERROR 404</h1>
                <Link to={URLS.HOME.url}>
                    <IonButton>חזרה לדף הבית</IonButton>
                </Link>
                <br />
                <Footer />
            </IonContent>
        </IonApp>
    );
};

export default Error404;
